import clsx from 'clsx';
import styles from './WordBox.module.scss';
import { useEffect, useRef, useState } from 'react';

const comparePosition = (p1, p2) => {
    return p1.row === p2.row && p1.column === p2.column
}
function WordBox({ children, className, box, position, inputing, updateInputing, handleMoveFocus, handleOnBlurWordBox, ...rest }) {
    const [text, setText] = useState(box.text || '');

    const inputRef = useRef(null);

    const handleOnDoubleClick = (e) => {
        updateInputing(position);
        if (inputRef && inputRef.current) {
            requestAnimationFrame(() => {
                inputRef.current.focus();
                inputRef.current.select();
            });
            // setTimeout(() => {
            //     inputRef.current.focus();
            //     inputRef.current.select();
            // }, 0);
        }
    }

    const handleTab = (e) => {
        if (e.key === 'Tab') {
            e.preventDefault();
            handleMoveFocus(position);
        }
    }

    const handleOnBlur = (e) => {
        if (handleOnBlurWordBox)
            handleOnBlurWordBox(position, text);
    }
    const handleOnChange = (e) => {
        setText(e.target.value);
    }
    useEffect(() => {
        if (comparePosition(position, inputing)) {
            if (inputRef && inputRef.current) {
                setTimeout(() => {
                    inputRef.current.focus();
                    inputRef.current.select();
                }, 0);
            }
        }
    }, [inputing, position])

    useEffect(() => {
        setText(box.text);
    }, [box])
    // console.log('re-render WordBox')
    return box.hide ? (
        <div {...rest} className={clsx(styles.box, styles.hide, className)}>
        </div>
    ) : (
        <div {...rest} className={clsx(styles.box, comparePosition(position, inputing) && styles.focus, box.status && box.status === 'right' && styles.right, box.status && box.status === 'wrong' && styles.wrong, className)}>
            <div className={styles.text} onClick={() => handleOnDoubleClick()}>{text}</div>
            <input
                name="textbox"
                className={clsx(styles.input)}
                type="text"
                value={text}
                onChange={handleOnChange}
                maxLength={1}
                ref={inputRef}
                style={{
                    // visibility: comparePosition(position, inputing) ? 'visible' : 'hidden'
                    zIndex: comparePosition(position, inputing) ? 100 : 98
                }}
                onBlur={handleOnBlur}
                onKeyDown={(e) => handleTab(e)}
            />
            {box.start && <div className={clsx(styles.no, styles.no1, styles.row)}>{box.start[0].no}</div>}
            {box.start && box.start[0].direction === 'column' && <div className={clsx(styles.direction, styles.column)}><i className="fa-solid fa-arrow-down-long"></i></div>}
            {box.start && box.start[0].direction === 'row' && <div className={clsx(styles.direction, styles.row)}><i className="fa-solid fa-arrow-right-long"></i></div>}

            {box.start && box.start.length >= 2 && <div className={clsx(styles.no, styles.no2, styles.row)}>{box.start[1].no}</div>}
            {box.start && box.start.length >= 2 && box.start[1].direction === 'column' && <div className={clsx(styles.direction, styles.column2)}><i className="fa-solid fa-arrow-down-long"></i></div>}
            {box.start && box.start.length >= 2 && box.start[1].direction === 'row' && <div className={clsx(styles.direction, styles.row2)}><i className="fa-solid fa-arrow-right-long"></i></div>}
        </div>
    );
}
export default WordBox;
